import {
	FETCH_STEEL_SMELTER_ALL_TIME_BY_SMELTER_DATA_INIT,
	FETCH_STEEL_SMELTER_ALL_TIME_BY_SMELTER_DATA,
	FETCH_STEEL_SMELTER_ALL_TIME_BY_SMELTER_DATA_ERR
} from '../../actions';

export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_STEEL_SMELTER_ALL_TIME_BY_SMELTER_DATA_INIT:
			return { ...action.payload, loading: true };
		case FETCH_STEEL_SMELTER_ALL_TIME_BY_SMELTER_DATA:
		case FETCH_STEEL_SMELTER_ALL_TIME_BY_SMELTER_DATA_ERR:
			if (
				action.payload.timestamp &&
				action.payload.timestamp !== state.timestamp
			) {
				return state;
			}
			return action.payload;
		default:
			return state;
	}
};
